import {
  UserAddOutlined,
  UserOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { Checkbox, Progress, Input } from "antd";
import Main from "../components/layout/Main";
import Header from "../components/layout/Header";
import React from "react";
import { post } from "../Libraries/Ajax/HttpService";
import { Component } from "react";
import "react-toastify/dist/ReactToastify.css";

import { toast } from "react-toastify";
import back from "../assets/images/back.svg";
import zxcvbn from "zxcvbn";
import { withNavigation } from "./withNavigation";
class Registration extends Component {
  state = {
    names: "",
    active: true,
    type: "",
    values: "",
    frequency: "",
    selected: "",
    mcdata: JSON.parse(localStorage.getItem("MCData")),
    selectedDistricts: [],
    score: "",
    feedback: "",
    confirm_password: "",
    confirm_feedback: "",
    availableDistricts:
      JSON.parse(localStorage.getItem("MCData"))?.district || [],
  };
  //  componentDidMount() {
  //   const isMizuWatch = window.location.href.includes("mizuwatch.com");
  //   document.title = isMizuWatch ? "MizuWatch" : "MizuSmart";
  // }
  onNamesChange = (e) => {
    this.setState({
      names: e.target.value,
    });
  };
  onMouseClickpath = (event) => {
    this.props.navigate("/registration");
  };

  onselectClick = () => {
    this.props.navigate("/settingsuser");
  };
  onselectClicks = () => {
    this.props.navigate("/list");
  };
  onselectClickaccount = () => {
    this.props.navigate("/accountnames");
  };

  onMouseClick = (event) => {
    this.setState({
      selected: event.target.value,
    });
  };

  onselectClickss = (e) => {
    this.props.navigate(-1);
  };
  onselectMetermangement = () => {
    this.props.navigate("/metermanagement");
  };

  getColor = () => {
    const { score } = this.state;
    switch (score) {
      case 0:
        return "gray";
      case 1:
        return "red";
      case 2:
        return "orange";
      case 3:
        return "green";
      case 4:
        return "green";
      default:
        return "gray";
    }
  };

  getCustomScore = (password, zxcvbnScore) => {
    let score = zxcvbnScore;
    console.log("score xvb ", score);
    // Enforce minimum length
    if (password.length < 8) {
      score = 0;
      console.log("score is ", score);
      return score;
    }
    // Enforce at least one capital letter, one number, and one special character
    const hasCapitalLetter = /[A-Z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    if (!hasCapitalLetter || !hasNumber || !hasSpecialChar) {
      score = Math.min(score, 2); // Lower the score if the requirements are not met
      console.log("score is sss", score);
      score = 1;
    }

    if (
      hasCapitalLetter &&
      hasNumber &&
      hasSpecialChar &&
      password.length > 8
    ) {
      score = 2;
      if (password.length > 12) {
        score = 3;
      }
      if (password.length > 21) {
        score = 4;
      }
    }
    console.log("score is ", score);

    return score;
  };

  getFeedback = (temp_password) => {
    const feed =
      "Password Requirements:Minimum Length: 8 characters Uppercase Letter: At least one uppercase letter (A-Z) Number: At least one number (0-9) Special Character: At least one special character (e.g., @, #, $, etc.) No Spaces: Password must not contain spaces";
    if (temp_password.length < 1) {
      return "";
    } else {
      return feed;
    }
    return "";
  };

  handlePasswordChange = (e) => {
    const password = e.target.value;
    const hasWhitespace = /\s/.test(password);

    if (password.length <= 32 && !hasWhitespace) {
      const result = zxcvbn(password);
      const customScore = this.getCustomScore(password, result.score);
      const feedback = this.getFeedback(password);
      this.setState({
        frequency: password,
        score: customScore,
        feedback: feedback,
      });
    } else if (hasWhitespace) {
      // Handle case where password contains whitespace
      this.setState({
        feedback: "Password should not contain spaces.",
      });
    } else {
      // Handle case where password exceeds the maximum length
      this.setState({
        feedback: "Password exceeds the maximum length of 32 characters.",
      });
    }
  };

  handleConfirmChange = (e) => {
    const confirm_pass = e.target.value;
    if (confirm_pass == this.state.frequency) {
      this.setState({
        confirm_feedback: "",
        confirm_password: confirm_pass,
        feedback: "",
      });
    } else {
      let msg = "";
      if (
        this.state.confirm_password &&
        this.state.confirm_password.length > 1
      ) {
        msg = "Password is not matching.";
      }

      this.setState({
        confirm_feedback: msg,
        confirm_password: confirm_pass,
      });
    }
  };

  // handleCheckboxChange = (value) => {
  //   const { selectedDistricts } = this.state;

  //   const districtsArray = Array.isArray(selectedDistricts)
  //     ? selectedDistricts.slice()
  //     : [];

  //   if (districtsArray.includes(value)) {
  //     this.setState({
  //       selectedDistricts: districtsArray.filter(
  //         (district) => district !== value
  //       ),
  //     });
  //     console.log(
  //       "if -removed-- >",
  //       districtsArray.filter((district) => district !== value)
  //     );
  //   } else {
  //     this.setState({
  //       selectedDistricts: [...districtsArray, value],
  //     });
  //     // console.log("else---- -inc-- >",[...districtsArray, value])
  //     // console.log("else---- -inc-- >",[...districtsArray, value].join(', '))
  //   }
  // };
  handleCheckboxChange = (value) => {
    const { selectedDistricts } = this.state;
    let updatedDistricts = [...selectedDistricts];

    if (updatedDistricts.includes(value)) {
      updatedDistricts = updatedDistricts.filter((d) => d !== value);
    } else {
      updatedDistricts.push(value);
    }

    this.setState({ selectedDistricts: updatedDistricts });
    console.log("Updated districts:", updatedDistricts);
  };

  onTypeChange = (e) => {
    this.setState({
      type: e.target.value,
    });
  };
  onValueChange = (e) => {
    this.setState({
      values: e.target.value,
    });
  };

  // password strength
  onFrequencyChange = (e) => {
    this.setState({
      frequency: e.target.value,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const StrDistricts = this.state.selectedDistricts.join(",");
    if (
      this.state.frequency == this.state.confirm_password &&
      this.state.score >= 2
    ) {
      const data = {
        first_name: this.state.names,
        last_name: this.state.type,
        email: this.state.values,
        password: this.state.frequency,
        user_type: this.state.selected,
        districts: StrDistricts,
      };
      console.log("data", data);
      post("apis/signup", data).then(
        (response) => {
          console.log("data", data);

          if (response.data.status == true) {
            setTimeout(() => {
              toast.success("User Added");
            }, 1000);

            //  e.preventDefault();
            //  e.target.reset();
            setTimeout(() => {
              this.props.navigate("/list");
            }, 2000);
          } else {
            toast.info(response.data.message, {
              autoClose: 3000,
            });
          }
        },
        (error) => {
          toast.error(error.response.data.message, {
            autoClose: 3000,
          });
        }
      );
    } else {
      toast.info(
        "Please complete all required fields before submitting the form. ",
        {
          autoClose: 3000,
        }
      );
    }
  };

  render() {
    return (
      <>
        {/* <ToastContainer /> */}
        {/* <head>
        <title> {window.location.href.indexOf("mizuwatch.com") > -1?"MizuWatch":"MizuSmart"}  </title></head> */}
        <Header />
        <Main>
          <div>
            <div className="d-flex align-items-center flex-wrap justify-content-between  mb-4">
              <div className="d-flex align-items-center">
                <img
                  src={back}
                  alt=""
                  style={{ width: "10px", cursor: "pointer" }}
                  onClick={this.onselectClickss}
                />
                {/* <h3 className="mb-0 ms-3">User Registration</h3> */}
                <div className="d-flex align-items-center">
                  {this.state.mcdata.mcdatas.type === "U" &&
                  this.state.mcdata.mcdatas.type === "U" ? (
                    ""
                  ) : (
                    <>
                      <div
                        className="new-box-padding   align-self-center c-pointer "
                        onClick={this.onselectClick}
                        style={{ borderBottom: "2px solid #ccc" }}
                      >
                        {" "}
                        Settings
                      </div>
                      <div
                        className=""
                        style={{
                          width: "2px",
                          height: "25px",
                          background: "#ccc",
                        }}
                      ></div>
                    </>
                  )}
                  {this.state.mcdata.mcdatas.type === "U" &&
                  this.state.mcdata.mcdatas.type === "U" ? (
                    ""
                  ) : (
                    <>
                      <div
                        className="new-box-padding   align-self-center c-pointer "
                        onClick={this.onselectClicks}
                        style={{ borderBottom: "2px solid #ccc" }}
                      >
                        Users
                      </div>
                      <div
                        className=""
                        style={{
                          width: "2px",
                          height: "25px",
                          background: "#ccc",
                        }}
                      ></div>
                    </>
                  )}
                  <div
                    className="new-box-padding  text-blue  align-self-center c-pointer"
                    style={{
                      borderBottom: "2px solid #1998f0",
                      borderRadius: "0",
                    }}
                    onClick={this.onMouseClickpath}
                  >
                    {" "}
                    User Registration
                  </div>
                  <div
                    className=""
                    style={{ width: "2px", height: "25px", background: "#ccc" }}
                  ></div>
                </div>
              </div>
            </div>
          </div>

          <div className="post">
            <form
              className="form-horizontal bg-white mx-auto login-form rounded p-5 border-2 shadow my-3"
              onSubmit={this.handleSubmit}
            >
              <div className="col-lg-4 m-auto">
                <div class="forms-inputs mt-3">
                  <span for="pwd">First Name</span>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Enter Name"
                    value={this.state.names}
                    onChange={this.onNamesChange}
                    required
                  />
                </div>

                <div class="forms-inputs">
                  <span for="pwd">Last Name</span>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Enter Last Name"
                    value={this.state.type}
                    autocomplete="new-password"
                    onChange={this.onTypeChange}
                    required
                  />
                </div>

                <div class="forms-inputs">
                  <span for="email">Email</span>
                  <input
                    type="email"
                    class="form-control"
                    placeholder="Enter Email"
                    value={this.state.values}
                    autocomplete="new-password"
                    onChange={this.onValueChange}
                    required
                  />
                </div>
                <div class="forms-inputs mb-4">
                  <span for="pwd">Password</span>
                  <input
                    type="password"
                    class="form-control"
                    placeholder="Enter Password"
                    value={this.state.frequency}
                    autocomplete="new-password"
                    onChange={this.handlePasswordChange}
                    required
                  />
                  {this.state.frequency.length > 0 && (
                    <>
                      <Progress
                        percent={(this.state.score + 1) * 10}
                        strokeColor={this.getColor()}
                        showInfo={false}
                        style={{ marginTop: "10px" }}
                      />

                      <div style={{ textAlign: "center", marginTop: "10px" }}>
                        {this.state.frequency != this.state.confirm_password &&
                          [
                            "Strength :  Very Weak",
                            "Strength : Weak",
                            "Strength : Good",
                            "Strong",
                            "Very Strong",
                          ][this.state.score]}
                      </div>
                      <div style={{ color: "red", marginTop: "10px" }}>
                        <p>Password Requirements:</p>
                        <ul>
                          <li>Minimum Length: 8 characters</li>
                          <li>
                            Uppercase Letter: At least one uppercase letter
                            (A-Z)
                          </li>
                          <li>Number: At least one number (0-9)</li>
                          <li>
                            Special Character: At least one special character
                            (e.g., @, #, $, etc.)
                          </li>
                          <li>No Spaces: Password must not contain spaces</li>
                        </ul>
                      </div>
                    </>
                  )}
                </div>
                {this.state.score >= 2 && (
                  <div class="forms-inputs">
                    <span for="confirm">Confirm Password</span>
                    <input
                      type="password"
                      class="form-control"
                      placeholder="Re enter password"
                      value={this.state.confirm_password}
                      autocomplete="new-password"
                      onChange={this.handleConfirmChange}
                      required
                    />{" "}
                    {this.state.confirm_feedback && (
                      <div
                        style={{
                          color: "red",
                          textAlign: "center",
                          marginTop: "10px",
                        }}
                      >
                        {this.state.confirm_feedback}
                      </div>
                    )}
                  </div>
                )}

                {JSON.parse(localStorage.getItem("MCData")).mcdatas
                  ?.all_user_creation === true ? (
                  <>
                    {" "}
                    <select
                      name="All meters"
                      id="selector"
                      className="box w-100 mt-3"
                      style={{ height: "45px", fontWeight: 400 }}
                      onChange={this.onMouseClick}
                      placeholder="Please Select User Type"
                    >
                      <option value="" disabled selected>
                        Please Select User Type
                      </option>
                      <option value="SA">Super Admin</option>
                      <option value="A">Admin </option>
                      <option value="U">User</option>
                    </select>
                  </>
                ) : (
                  <>
                    {" "}
                    <select
                      name="All meters"
                      id="selector"
                      className="box w-100 mt-3"
                      style={{ height: "45px", fontWeight: 400 }}
                      onChange={this.onMouseClick}
                      placeholder="Please Select User Type"
                    >
                      <option value="" disabled selected>
                        Please Select User Type
                      </option>

                      <option value="U">User</option>
                    </select>
                  </>
                )}
                <div class="col-md-4 mt-5">
                  <h6
                    className="w-100  total-flow-font-size"
                    style={{ color: "#515252" }}
                  >
                    <b>District Selection</b>
                  </h6>
                  {/* <div class="form-check ps-0 d-flex align-items-center mt-3">
                    <Checkbox
                      value="GPMD"
                      checked={this.state.selectedDistricts.includes("GPMD")}
                      onChange={() => this.handleCheckboxChange("GPMD")}
                    >
                      <span className="ms-2" style={{ color: "#515252" }}>
                        <b>GPMD</b>
                      </span>
                    </Checkbox>
                    <Checkbox
                      value="FB151"
                      checked={this.state.selectedDistricts.includes("FB151")}
                      onChange={() => this.handleCheckboxChange("FB151")}
                    >
                      <span className="ms-2" style={{ color: "#515252" }}>
                        <b>FB&nbsp;151</b>
                      </span>
                    </Checkbox>

                    <br />
                  </div> */}
                  <div class="form-check ps-0 d-flex align-items-center mt-3">
                    {this.state.availableDistricts.map((d) => (
                      <Checkbox
                        key={d.id}
                        value={d.district_name} // "GPMD", "FB151"
                        checked={this.state.selectedDistricts.includes(
                          d.district_name
                        )}
                        onChange={() =>
                          this.handleCheckboxChange(d.district_name)
                        }
                      >
                        <span className="ms-2" style={{ color: "#515252" }}>
                          <b>{d.district_display_name}</b>
                        </span>
                         </Checkbox>
                         
                    ))}
                     <br />
                  </div>
                </div>
                <div class="form-group mb-3">
                  <div class="col-sm-offset-2">
                    <button
                      type="submit"
                      class="btn w-100 btn-submit fs-20 mt-20"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </Main>
      </>
    );
  }
}

// export default Registration;
export default withNavigation(Registration);
